import {
  AppBar,
  Container,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import LOGO from "assets/img/logo.png";
import clsx from "clsx";
import PrivateRoute from "components/PrivateRoute";
import { NAME, TOKEN } from "constants/config";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { fetchFarmList } from "./adminSlice";
import ListFarms from "./pages/ListFarm/ListFarm";
import ListItems from "./components/ListItem";
import TestHistory from "./pages/TestHistory/TestHistory";
import TotalFarm from "./pages/TotalFarm/TotalFarm";
import Frquency from "./pages/Frequency/Frequency";
import DetailResultPage from "./pages/DetailResult/DetailResult";
import AssessmentPage from "./pages/Assessment/AssessmentPage";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 8px",
    ...theme.mixins.toolbar,
  },
  username: {
    fontSize: 15,
    marginRight: 30,
    color: "#fff",
    "& > span": {
      color: "#c2fa77",
    },
  },
  icon_logout: {
    cursor: "pointer",
    color: "#ea8c8c",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    cursor: "pointer",
  },
  logo: {
    objectFit: "cover",
    cursor: "pointer",
    marginLeft: 15,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    maxHeight: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Dashboard() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const username = localStorage.getItem(NAME);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchFarmList());
  }, [dispatch]);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleLogout = () => {
    localStorage.removeItem(TOKEN);
    navigate("/");
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {/* Dashboard */}
          </Typography>
          <Typography variant="subtitle2" className={classes.username}>
            Hi ,{" "}
            <Typography variant="subtitle2" component="span">
              {username}
            </Typography>
          </Typography>
          <Tooltip title="Đăng xuất" onClick={handleLogout}>
            <ExitToAppIcon className={classes.icon_logout} />
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <img
            src={LOGO}
            alt="logo"
            className={classes.logo}
            onClick={() => navigate("/admin")}
          />

          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        {/* Menu list */}
        <List>
          <ListItems />
        </List>
        <Divider />
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="xl" className={classes.container}>
          <Routes>
            <Route
              path="test-history"
              element={
                <PrivateRoute>
                  <TestHistory />
                </PrivateRoute>
              }
            />
            <Route
              path="farm"
              element={
                <PrivateRoute>
                  <ListFarms />
                </PrivateRoute>
              }
            />

            <Route
              path="total-farm"
              element={
                <PrivateRoute>
                  <TotalFarm />
                </PrivateRoute>
              }
            />

            <Route
              path="frequency"
              element={
                <PrivateRoute>
                  <Frquency />
                </PrivateRoute>
              }
            />
            <Route
              path="detail-result"
              element={
                <PrivateRoute>
                  <DetailResultPage />
                </PrivateRoute>
              }
            />
              <Route
              path="assessment"
              element={
                <PrivateRoute>
                  <AssessmentPage />
                </PrivateRoute>
              }
            />

            {/* <Route path="/" element={<SignIn />} /> */}
          </Routes>
        </Container>
      </main>
    </div>
  );
}
